import { uniqueId } from 'lodash';

export function generateUniqueId(tag: string) {
  return uniqueId(tag);
}
